import { z } from 'zod';
export const TIPOS_DOCUMENTO = ['DNI', 'PASAPORTE', 'CUIT', 'CUIL', 'OTRO'];
export const ClienteSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    apellido: z.string().nullable().optional(),
    tipoDocumento: z.enum(TIPOS_DOCUMENTO).nullable().optional(),
    nroDocumento: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    fechaNacimiento: z.string().nullable().optional(),
    observaciones: z.string().nullable().optional(),
    canalAlta: z.string().nullable().optional(),
    anonimizado: z.boolean(),
    activo: z.boolean(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
});
export const ClienteFormSchema = z.object({
    nombre: z.string().trim().min(1, 'El nombre es obligatorio').max(100),
    apellido: z.string().trim().max(100).optional().or(z.literal('')),
    tipoDocumento: z.enum(TIPOS_DOCUMENTO).optional().or(z.literal('')),
    nroDocumento: z.string().trim().max(50).optional().or(z.literal('')),
    email: z.string().trim().email('Email inválido').max(150).optional().or(z.literal('')),
    telefono: z.string().trim().max(50).optional().or(z.literal('')),
    fechaNacimiento: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
    observaciones: z.string().max(2000).optional().or(z.literal('')),
});
export const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const ClientesPaginadosSchema = z.object({
    items: z.array(ClienteSchema),
    paginacion: PaginacionSchema,
});
